// @flow
import * as React from "react"
import { compose, type HOC, withStateHandlers } from "recompose"
import withConnect from "hoc/withConnect"
import withUser from "hoc/withUser"
import withQuery from "hoc/withQuery"
import withSubmit from "hoc/withSubmit"
import withMutation from "hoc/withMutation"
import { trackPerksSubscription } from "analytics/user/analyticsTraits"
import getErrorMessage from "common/graphql/getErrorMessage"
import { Title } from "componentsStyled/Typography/Titles"
import { Text } from "componentsStyled/Typography/Texts"
import { getPaymentMethodQuery } from "data/user/graphql/queries"
import { createSubscriptionMutation } from "data/subscriptions/graphql/mutations"
import type { Plan } from "data/plans/types"
import { openModal } from "data/modals/actions"
import ModalBody from "modals/_Body"
import ModalContent from "modals/_Content"
import CreditCard from "modals/CreditCard"
import SubscribePlanConfirmation from "modals/SubscribePlanConfirmation"
import PlanDetails from "./PlanDetails"
import ConfirmPayment from "./ConfirmPayment"
import PromocodeInput from "./PromocodeInput"
import { Content } from "./styled"

type Props = {|
  close: Function,
  plan: Plan,
  details: boolean,
  fromCheckout?: boolean,
|}

const SubscribePlan = ({ close, plan, details, data, user, submit, loading, setDetails, promocode, setPromocode }) => (
  <ModalBody close={close}>
    <ModalContent>
      <Content>
        <Title center>{plan.title}</Title>
        <Text center>{plan.subtitle}</Text>
        <br />
        {!details && <PromocodeInput onChange={setPromocode} value={promocode} /> }
        {details
          ? <PlanDetails plan={plan} onClick={() => setDetails(false)} currentStep="1" finalStep="3" />
          : user.customer
            ? <ConfirmPayment data={data} loading={loading} submit={submit} planTitle={plan.title} promocode={promocode} currentStep="3" finalStep="3" />
            : <CreditCard close={() => {}} type={"add"} displayText="" submitText="Confirm your card" currentStep="2" finalStep="3" minimal />
        }
      </Content>
    </ModalContent>
  </ModalBody>
)

const mapDispatchToProps = {
  openModal,
}

const enhancer: HOC<*, Props> = compose(
  withConnect(() => ({}), mapDispatchToProps),
  withStateHandlers(
    props => ({
      details: props.details,
    }),
    {
      setDetails: () => (details: boolean) => ({ details }),
    },
  ),
  withStateHandlers(
    {
      promocode: undefined,
    },
    {
      setPromocode: () => (event) => ({ promocode: event.target.value }),
    },
  ),
  withUser(),
  withQuery(getPaymentMethodQuery, {
    noEmpty: true,
    config: {
      skip: props => !props.user.customer,
    },
  }),
  withMutation(createSubscriptionMutation),
  withSubmit({
    submit: props => (promocode?: string) => props.submitMutation({
      input: {
        slug: props.plan.slug,
        code: promocode,
      },
    }),
    successText: props => "Oooh, this is gonna be good.",
    onSuccess: props => () => {
      props.close()
      props.openModal(SubscribePlanConfirmation, {
        plan: props.plan,
        currentStep: "3",
        finalStep: "3",
        fromCheckout: props.fromCheckout,
      })
      trackPerksSubscription(props.user.email)
    },
    onError: props => error => getErrorMessage(error),
  }),
)

export default enhancer(SubscribePlan)



// WEBPACK FOOTER //
// ./src/modals/SubscribePlan/index.js